import {IconButton} from '@wandb/components';
import React from 'react';

type RowPinningProps = {
  isRunBaseline: boolean;
  isRunPinned: boolean;
  isSingleMode: boolean;
  onUnbaselineRow: () => void;
  onUnpinRow: () => void;
};

export function RowPinning({
  isRunBaseline,
  isRunPinned,
  isSingleMode,
  onUnbaselineRow,
  onUnpinRow,
}: RowPinningProps) {
  if (isSingleMode) {
    return null;
  }

  if (isRunBaseline) {
    return (
      <IconButton
        icon="bookmark-filled"
        onPress={onUnbaselineRow}
        aria-label="Unbaseline run"
        tooltip={{children: 'Click to remove baseline'}}
        size="sm"
        variant="ghost"
      />
    );
  }
  if (isRunPinned) {
    return (
      <IconButton
        icon="pin-filled"
        onPress={onUnpinRow}
        aria-label="Unpin run"
        tooltip={{children: 'Click to remove pin'}}
        size="sm"
        variant="ghost"
      />
    );
  }
  return null;
}
